import { render, staticRenderFns } from "./modal-work-item-comments.vue?vue&type=template&id=2f404cc0&scoped=true"
import script from "./modal-work-item-comments.vue?vue&type=script&lang=js"
export * from "./modal-work-item-comments.vue?vue&type=script&lang=js"
import style0 from "./modal-work-item-comments.vue?vue&type=style&index=0&id=2f404cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f404cc0",
  null
  
)

export default component.exports